import { DefaultOptions, UseMutationOptions, UseQueryOptions } from "react-query";

import { ONE_MINUTE_MILLISECONDS } from "../utils/time";
import { ResponseError } from "./fetchWithAuth";

const MAX_RETRY_COUNT = 1;

function retry(failureCount: number, err: ResponseError): boolean {
    // do not retry if authorization error
    if (err.statusCode === 403) {
        return false;
    }
    return failureCount < MAX_RETRY_COUNT;
}

export const QUERY_DEFAULT_OPTIONS: DefaultOptions<ResponseError> = {
    queries: {
        refetchOnWindowFocus: false,
        retry,
        staleTime: ONE_MINUTE_MILLISECONDS,
    },
};

export type QueryOptions<T, E = unknown> = Omit<UseQueryOptions<T, E, T>, "queryKey" | "queryFn">;
export type MutationOptions<Response, Request, TError = unknown> = Omit<
    UseMutationOptions<Response, TError, Request>,
    "mutationFn"
>;
